

/*
TODO

Trebalo bi da stavimo npr u biblioteku parametara da mozemo da unesemo putanju API-ja da kada radimo sa test bazom. Za testiranje stoji jedna putanja a kada radimo sa realnom druga i da ne bi morali da menjamo to kroz kod vec preko parametra definisemo sta koristimo. Sada sve API-je povlaci sa realne baze a za test ce nam trebati Test baza.
Ovo isto vazi i za putanju kada saljemo API sa sastavnicom.

Ovu su putanje
Realna baza
http://api.orders.termovent.o3on.rs/api/Orders/GetByKey/1801OR0000002
Test baza
http://172.16.10.70/api/api/Orders/GetByKey/1801OR0000002

Znaci deo koji se menja je:
http://api.orders.termovent.o3on.rs
http://172.16.10.70/api

ostali deo putanje treba da je konstantan. (Primetices da kada je test ima dva puta /api/api da te ne zbuni. Ne znam zasto je tako ali tako radi)

*/

import config from "../utils/config";

/*
const meskey = 'O3Key';
const mesval = '72AAAE63-4B5D-43EF-B757-8EF675F3EE41-E4F4B731-A2AB-4EE3-B14E-283ACC8F7285';
*/


const COMPANY_MES_API_PREFIX = 'http://api.orders.termovent.o3on.rs'; // PROD
// const COMPANY_MES_API_PREFIX_2 = 'http://orders.termovent.o3on.rs/services'; // PROD 2
// const COMPANY_MES_API_TEST_PREFIX = 'http://172.16.10.70/api';
const COMPANY_MES_API_STG_PREFIX = 'http://172.16.10.70/api'; // bivši test je sada STG
const COMPANY_MES_API_TEST_PREFIX = 'http://172.16.10.70:88/api'; // ovoje sada test

export const COMPANY_MES_APIKEY_HEADER_KEY = 'O3Key';
export const COMPANY_MES_APIKEY_HEADER_VALUE = '72AAAE63-4B5D-43EF-B757-8EF675F3EE41-E4F4B731-A2AB-4EE3-B14E-283ACC8F7285';


// TODO
/*
const company_api_prefix_get = () => {
  // TODO
  if (config.company_env_mes_test_is_enabled !== false) {
    return COMPANY_MES_API_TEST_PREFIX; // test api
  }
  return COMPANY_MES_API_PREFIX; // pravi api
};
*/
const company_api_prefix_get = () => {
  // TODO
  if (config.company_env_mes === 'TEST') {
    return COMPANY_MES_API_TEST_PREFIX; // test api
  }
  if (config.company_env_mes === 'STG') {
    return COMPANY_MES_API_STG_PREFIX; // STG api
  }
  if (config.company_env_mes === 'PROD') {
    return COMPANY_MES_API_PREFIX; // pravi api PROD
  }
  // return 'http://greska/api';
  return COMPANY_MES_API_TEST_PREFIX; // test api DEFAULT za sada
};


//

export const companyUrlLib = {};

companyUrlLib.getExternalOrdersList = () => {
  // GET liste narudzbi
  // let url = 'http://api.orders.termovent.o3on.rs/api/Orders/Get/'; // GET
  let url = company_api_prefix_get() + '/api/Orders/Get/'; // GET
  return url;
};
companyUrlLib.getExternalOrderDataByKey = (broj_ordera) => {
  // GET podaci o pojedinacnom orderu/narudzbi
  // http://api.orders.termovent.o3on.rs/api/Orders/GetByKey/1801OR0000002
  // let url = 'http://api.orders.termovent.o3on.rs/api/Orders/GetByKey/' + broj_ordera; // GET
  let url = company_api_prefix_get() + '/api/Orders/GetByKey/' + broj_ordera; // GET
  return url;
};
companyUrlLib.getExternalOrderFilesByKey = (broj_ordera) => {
  // GET stvake/fajlovi jednog orrdera
  // let url = 'http://api.orders.termovent.o3on.rs/api/Orders/GetFilesByKey/ORDER:' + broj_ordera; // GET
  let url = company_api_prefix_get() + '/api/Orders/GetFilesByKey/ORDER:' + broj_ordera; // GET
  return url;
};
companyUrlLib.getExternalOrderFilesByKey = (broj_ordera) => {
  // GET stvake/fajlovi jednog orrdera
  // let url = 'http://api.orders.termovent.o3on.rs/api/Orders/GetFilesByKey/ORDER:' + broj_ordera; // GET
  let url = company_api_prefix_get() + '/api/Orders/GetFilesByKey/ORDER:' + broj_ordera; // GET
  return url;
};
companyUrlLib.postExternalSpreadsheetUpload = () => {
  // let url = 'http://api.orders.termovent.o3on.rs/api/Spreadsheet/Post'; // POST
  let url = company_api_prefix_get() + '/api/Spreadsheet/Post'; // GET
  return url;
};
companyUrlLib.getExternalUsersList = () => {
  // GET podaci o svim korisnicima
  let url = company_api_prefix_get() + '/api/User/Get'; // GET
  return url;
};
companyUrlLib.getExternalUserById = (id) => {
  // GET podaci o pojedinacnom korisniku
  let url = company_api_prefix_get() + '/api/User/GetById/' + id; // GET
  return url;
};
companyUrlLib.getExternalBomInfoByRevId = (rev_id) => {
  // GET dodatni info o sastavnici
  // http://172.16.10.70/api/api/Orders/GetInfoByBomId/61
  let url = company_api_prefix_get() + '/api/Orders/GetInfoByBomId/' + rev_id; // GET
  return url;
};

/*
API preko kojeg mozemo da vidimo status stavke je
http://orders.termovent.o3on.rs/services/api/OrderItems/GetByKey/2401OR0000067
Atribut je "_Status"

API ovih statusa zbog naziva je
http://orders.termovent.o3on.rs/services/api/OrderItemStatus/Get

Ovo moze da se vec implementira a akcije koje ce izvoditi na osnovu ovih statusa cemo dogovoriti zajedno naknadno.
*/
companyUrlLib.getExternalOrderItemStatusList = () => {
  // GET lista statusa stavke narudzbe
  let url = company_api_prefix_get() + '/api/OrderItemStatus/Get'; // GET
  return url;
};
companyUrlLib.getExternalOrderItemsByKey = (broj_ordera) => {
  // GET status stavke narudzbe
  let url = company_api_prefix_get() + '/api/OrderItems/GetByKey/' + broj_ordera + '?'; // GET
  return url;
};

/*
2023-04-26 Api za resurse

Lokacije
http://orders.termovent.o3on.rs/services/api/WorkOrderLocationResources/Get?skip=0&take=20&requireTotalCount=true&sort=[{"selector":"id","desc":false}]

Randni centri
http://orders.termovent.o3on.rs/services/api/WorkOrderLocationResourceItems/GetByKey/1?skip=0&take=20&requireTotalCount=true&sort=[{"selector":"id","desc":false}]

2024-08-29

Potrebno je da preko sledećeg API-ja updatujemo biblioteku Radni Centri Resursi.

http://orders.termovent.o3on.rs/services/api/WorkOrderLocationResourceItems/GetByKey/1

Da li postoji mogućnost da trenutno bez API-ja updatujemo?
*/
companyUrlLib.getExternalRadniCenriLokacije = () => {
  // GET status stavke narudzbe
  // http://orders.termovent.o3on.rs/services/api/WorkOrderLocationResources/Get?skip=0&take=20&requireTotalCount=true&sort=[{"selector":"id","desc":false}]
  let url = company_api_prefix_get() + '/api/WorkOrderLocationResources/Get'; // GET
  return url;
};
companyUrlLib.getExternalRadniCenriByLokacija = (lokacija_id) => {
  // GET status stavke narudzbe
  // http://orders.termovent.o3on.rs/services/api/WorkOrderLocationResourceItems/GetByKey/1
  let url = company_api_prefix_get() + '/api/WorkOrderLocationResourceItems/GetByKey/' + lokacija_id; // GET
  return url;
};


// detect is acKey internal
export const terCompanyUtils_detect_is_company_orderkey_regular = (company_orderkey) => {
  // if (filterBrojNarudzbe === "OR") {
  if (typeof company_orderkey === 'string' && company_orderkey.includes("OR")) {
    return true;
  } else {
    return false;
  }
};
export const terCompanyUtils_detect_is_company_orderkey_internal = (company_orderkey) => {
  // } else if (filterBrojNarudzbe === "IN") {
  if (typeof company_orderkey === 'string' && company_orderkey.includes("IN")) {
    return true;
  } else {
    return false;
  }
};
export const terCompanyUtils_detect_is_company_orderkey_other = (company_orderkey) => {
  // } else if (filterBrojNarudzbe === "OSTALE") {
  if (typeof company_orderkey === 'string' && (!company_orderkey.includes("OR") && !company_orderkey.includes("IN")) || typeof company_orderkey !== 'string') {
    return true;
  } else {
    return false;
  }
};

